import { Component, computed, inject, input, InputSignal, signal } from '@angular/core';
import { Product } from '../../../product/product.types';
import { depositConfig, resolveDepositCopy } from '../../../product/product.contstants';
import { CommonModule } from '@angular/common';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-pre-order-product',
    imports: [CommonModule],
    templateUrl: './pre-order-product.component.html',
    styleUrl: './pre-order-product.component.scss'
})
export class PreOrderProductComponent {

  #activeModal = inject(NgbActiveModal);

  productAvailabilityDisclaimer = signal('');

  data: InputSignal<Partial<Product> | undefined> = input(undefined, {
    transform: (data: Partial<Product> | undefined) => {
      if (!data) return data;
      const name = data.name;
      const variantName = data._variantData?.name && data._variantData?.name !== data.name ? data._variantData?.name : '';
      data.name = variantName ? `${name} | ${variantName}` : name
      data.price = data._variantData?.price || data.price;

      this.productAvailabilityDisclaimer.set(depositConfig.productAvailabilityDisclaimer(data?.preOrder?._readableEndDate?.readableString || ''));

      return data;
    }
  })

  depositConfig = computed(() => resolveDepositCopy(this.data()?.preOrder));

  /**
   * Texto del modal. Interpola el depósito, el precio y el saldo restante
   * (este último sólo lo usa `advance`).
   */
  message = computed(() => {
    const cfg = this.depositConfig();
    if (!cfg?.message) return '';
    const deposit = Number(this.data()?.preOrder?.deposit || 0);
    const price = Number(this.data()?.price || 0);
    return cfg.message(deposit, price, Math.max(0, price - deposit));
  })

  handleImageError(event: Event) {
    (event.target as HTMLImageElement).src = 'assets/images/product-placeholder.webp';
  }

  confirmPreOrder() {
    this.#activeModal.close({ sendPreOrder: true })
  }

  cancelPreOrder() {
    this.#activeModal.close()
  }

}
